import {PasswordContainer} from '../../../../components/PasswordContainer';
import {SettingsPageContainer} from '../../../../components/Settings/SettingsPageContainer';
import React, {useCallback, useEffect, useMemo, useState} from 'react';
import {useHistory, useLocation, useParams} from 'react-router-dom';
import {SettingInputComponent} from '../../../../components/Settings/SettingInputComponent';
import {useKeyboard} from '../../../../hooks/keyboard';
import {SettingSelectComponent} from '../../../../components/Settings/SettingSelectComponent';
import {SelectItem} from '../../../../components/Select';
import {useGlassControl} from '../../../../hooks/glass-control';
import {useSelector} from 'react-redux';
import {SettingReadOnlyRowComponent} from '../../../../components/Settings/SettingReadOnlyRowComponent';
import {STPUIEntity, STPUIType} from '../../../../store/control/state';
import {useMessage} from '../../../../hooks/message';
import {useSetSelector} from '../../../../hooks/set-selector';
import {useRPC} from '../../../../hooks/rpc';
import {
    CONTROL_TYPE_ID_AIR_CONDITIONER,
    CONTROL_TYPE_ID_THERMOSTAT,
    CONTROL_TYPE_ID_CONTACTOR,
    CONTROL_TYPE_ID_CURTAIN,
    CONTROL_TYPE_ID_LIGHT,
    CONTROL_TYPE_ID_PLUG,
    CONTROL_TYPE_ID_VALVE,
    BRIDGE_DEVICE_TYPE_ID_STPM, BRIDGE_DEVICE_TYPE_ID_STPM_F,CONTROL_TYPE_ID_FANCOIL, BRIDGE_DEVICE_TYPE_ID_STS_PLUS
} from '../../../../types/control';
import {useControlSelector} from '../../../../hooks/control-selector';
import {useQuestion} from '../../../../hooks/question';
import {useLocalization} from "../../../../hooks/localization";
import { SettingCheckBoxComponent } from '../../../../components/Settings/SettingCheckboxComponent';

export function STPEditorContentEditScreen() {
    const {t} = useLocalization();
    const params = useParams<{ id: string; device_id: string; }>();
    const question = useQuestion();
    const location = useLocation<{ controlId: string; bridgeDeviceId: string; virtualControlId: string; }>();
    const {success, failure} = useMessage();
    const history = useHistory();
    const [setActiveInput, renderKeyboard, currentInput] = useKeyboard();
    const [rpc] = useRPC();
    const [doubleButton, setDoubleButton] = useState(false);
    const controlList = useControlSelector();

    const backUrl = useMemo(() => `/settings/stp-editor/${params?.device_id || location?.state?.bridgeDeviceId}`, [params, location]);

    const controlTypes = useSelector(state => state.control.controlTypeList);
    const stpUIEntityList = useSelector((state) => state.control.stpUIList);
    const currentSTPUIEntity = useMemo(() => {
        return stpUIEntityList.find((e) =>
            e.id === params.id ||
            e.relational_id === location?.state?.controlId) || null;
    }, [stpUIEntityList, params, location]);
    const currentControl = useMemo(() => {
        if (currentSTPUIEntity?.type !== 'control' && currentSTPUIEntity?.type !== 'virtualControl') {
            return null;
        }

        return controlList.find((c) =>
            c.id === currentSTPUIEntity?.relational_id ||
            c.id === location?.state?.controlId) || null;
    }, [location, controlList, currentSTPUIEntity]);
    const controlTypeName = useMemo(() => controlTypes.find((t) => t.id === currentControl?.control.type_id), [controlTypes, currentControl?.control.type_id])?.name || '';

    const [displayName, setDisplayName] = useState<string>('');
    const [contentType, setContentType] = useState<SelectItem<STPUIType>>(null);
    const [groupType, setGroupType] = useState<SelectItem<string>>(null);

    const deviceList = useSelector(state => state.control.bridgeDeviceList);
    const bridgeDeviceTypeSet = useSetSelector(state => state.control.bridgeDeviceTypeList);
    const bridgeDevice = useMemo(() => deviceList.find((d) => d.id === params.device_id), [deviceList, params.device_id]);
    const bridgeDeviceType = useMemo(() => bridgeDeviceTypeSet[bridgeDevice.type_id], [bridgeDevice.type_id, bridgeDeviceTypeSet]);
    const CONTENT_TYPES = useMemo<{ label: string, value: STPUIType }[]>(() => [
        {label: t('weather_state_time'), value: 'weather'},
        {label: t('group_control'), value: 'group'},
        {label: t('scenario'), value: 'scenario'},
        {label: t('media'), value: 'media'},
        {label: t('air_conditioning'), value: 'air'},
    ], [t]);
    const contentTypeOptionList = useMemo(() =>
            bridgeDeviceType.has_home_page ? [...CONTENT_TYPES] : CONTENT_TYPES.filter(c => c.value !== 'group' && c.value !== 'weather' && c.value !== 'media' && c.value !== 'air'),
        [CONTENT_TYPES, bridgeDeviceType.has_home_page]);
    const {pageOptionList, pageNumber, setPageNumber, rowNumber, rowOptionList, setRowNumber, setOnlyEmptyPages} =
        useGlassControl(currentSTPUIEntity, params?.device_id, bridgeDeviceType, null, doubleButton)


    //todo sts sceneraio
    const deviceControls = controlList.filter(control => control.bridgeDeviceId === params.device_id);
    //const buttonNumbersForStsOnControl = deviceControls.map(control => control.glassControlParameters.button_number);
    const buttonNumbersForStsOnControl = deviceControls.flatMap(control => {
        if (control.control.type_id === CONTROL_TYPE_ID_CURTAIN) {
          const currentButtonNumber = control.glassControlParameters?.button_number;
          const nextButtonNumber = currentButtonNumber + 1;
          return [currentButtonNumber, nextButtonNumber];
        } else {
          return [control.glassControlParameters?.button_number];
        }
      });
    const newbuttonNumbersForStsOnControl = buttonNumbersForStsOnControl.map(num => num + 1);
    const deviceControlStpUI = stpUIEntityList.filter(control => control.bridge_device_id === params.device_id);
    const rowValuesStpUI = deviceControlStpUI.map(control => control.row_number);
    const allOptions = newbuttonNumbersForStsOnControl.concat(rowValuesStpUI);
    const defaultRowValues = rowOptionList.map((option) => option.value);
    const matchingRowValues = defaultRowValues.filter((buttonNumber) => !allOptions.includes(buttonNumber));
    const remainingOptionsWithLabel = matchingRowValues.map(option => ({value: option , label: `${option}`}));
    //const filteredRowList = rowOptionList.filter((row: any) => (row.value <= 5 && row.value >= 1 && row.value % 2 === 1 && row.value !== 3) ? row : null);
    const onClickChangeDoubleButtonStatus = useCallback(() => setDoubleButton(p => !p), [])
    const controlPageOptionsList = useMemo(() => {
        return pageOptionList.slice(1);
    }, [pageOptionList]);

    const onBlur = useCallback(() => {
        setActiveInput(null);
    }, [setActiveInput]);

    const onBackPressed = useCallback(() => {
        history.push(backUrl);
    }, [history, backUrl]);

    const onDeletePressed = useCallback(() => {
        question(t('are_you_sure_to_delete_ui_element'), () => {
            return rpc.deleteSTPUI(currentSTPUIEntity.id)
                .then(() => {
                    success(t('ui_element_successfully_deleted'));
                    onBackPressed();
                })
                .catch(failure);
        });
    }, [
        t,
        failure,
        onBackPressed,
        question,
        rpc,
        currentSTPUIEntity?.id,
        success,
    ]);

    const isFieldsValid = useCallback((): boolean => {
        if (!displayName) {
            failure(t('pls_enter_a_valid_display_name'));
            return false;
        }

        if (contentType?.value !== 'group' && pageNumber == null && bridgeDeviceType?.id !== '9' && bridgeDeviceType?.id !== '8' && bridgeDeviceType?.id !== '7') {
            failure(t('pls_select_a_page'));
            return false;
        }

        if (contentType?.value !== 'media' && contentType?.value !== 'air' && rowNumber == null) {
            failure(t('pls_select_a_row'));
            return false;
        }

        if (contentType?.value === 'group' && groupType == null) {
            failure(t('pls_select_group_control_type'));
            return false;
        }

        return true;
    }, [t, contentType?.value, displayName, failure, groupType, pageNumber, rowNumber, bridgeDeviceType?.id]);

    const onCreatePressed = useCallback(() => {
        if (!isFieldsValid()) {
            return;
        }

        const uiEntity: STPUIEntity = {
            id: currentSTPUIEntity?.id || undefined,
            display_name: displayName,
            type: currentSTPUIEntity == null ? contentType?.value : currentSTPUIEntity?.type,
            bridge_device_id: params?.device_id,
            relational_id: contentType?.value === "group" ? groupType?.value : currentSTPUIEntity?.relational_id,
            page_number: pageNumber?.value,

            row_number: rowNumber?.value || 0,
            extras: {
                ...currentSTPUIEntity?.extras,
                double_button: doubleButton || false,
            }
        }

        rpc.updateSTPUI(uiEntity)
            .then(() => {
                success(t(currentSTPUIEntity ? 'ui_element_successfully_edited' : 'ui_element_successfully_created'));
                onBackPressed();
            })
            .catch(failure);
    }, [t, groupType?.value, doubleButton, contentType?.value, currentSTPUIEntity, displayName, isFieldsValid, pageNumber?.value, params?.device_id, rowNumber?.value, success, onBackPressed, rpc, failure]);

    const buttons = useMemo(() =>
        [
            {
                text: t('delete'),
                className: 'mulberry-wood',
                onClick: onDeletePressed,
                hidden: currentControl != null || currentSTPUIEntity == null,
            },
            {
                text: t('save'),
                className: 'green',
                onClick: onCreatePressed,
            },
            {
                text: t('cancel'),
                className: 'red',
                url: backUrl,
            },
        ], [t, onDeletePressed, currentSTPUIEntity, onCreatePressed, backUrl, currentControl],
    );

    const GROUP_CONTROL_TYPES = useMemo(() => [
        {label: t('lamp'), value: CONTROL_TYPE_ID_LIGHT},
        {label: t('curtain'), value: CONTROL_TYPE_ID_CURTAIN},
        {label: t('plug'), value: CONTROL_TYPE_ID_PLUG},
        {label: t('air_conditioning'), value: CONTROL_TYPE_ID_AIR_CONDITIONER},
        {label: t('water_valve'), value: CONTROL_TYPE_ID_VALVE},
        {label: t('contactor'), value: CONTROL_TYPE_ID_CONTACTOR},
        {label: t('fancoil'), value: CONTROL_TYPE_ID_FANCOIL},
    ], [t]);

    useEffect(() => {
        if (currentSTPUIEntity == null) {
            return;
        }

        setDisplayName(currentSTPUIEntity.display_name);
        setRowNumber(rowOptionList.find(o => currentSTPUIEntity.row_number === o.value) || null)
        setPageNumber(pageOptionList.find(o => currentSTPUIEntity.page_number === o.value) || null);
        setDoubleButton(currentSTPUIEntity?.extras?.double_button || false)
        if (currentSTPUIEntity.type !== 'control' && currentSTPUIEntity.type !== 'virtualControl') {
            setContentType(contentTypeOptionList.find((t) => t.value === currentSTPUIEntity.type));
        }
        if (currentSTPUIEntity.type === 'group') {
            setGroupType(GROUP_CONTROL_TYPES.find((t) => t.value === currentSTPUIEntity.relational_id));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (contentType?.value === 'group') {
            setPageNumber(pageOptionList[0]);
        } else if (bridgeDeviceType.id === '23' || bridgeDeviceType.id === '9' || bridgeDeviceType.id === '8' || bridgeDeviceType.id === '7') {
            setPageNumber({label: '', value: 0});
        }
    }, [contentType, setPageNumber, pageOptionList, bridgeDeviceType.id]);

    useEffect(() => {
        if (contentType?.value === 'media' || contentType?.value === 'air') {
            setOnlyEmptyPages(true);
            return;
        }

        if (bridgeDeviceType.id === BRIDGE_DEVICE_TYPE_ID_STPM || BRIDGE_DEVICE_TYPE_ID_STPM_F || BRIDGE_DEVICE_TYPE_ID_STS_PLUS) {
            const control = controlList.find(c => c.id === currentSTPUIEntity?.relational_id);
            if (control) {
                if (control?.control?.type_id === CONTROL_TYPE_ID_THERMOSTAT || control?.control?.type_id === CONTROL_TYPE_ID_FANCOIL) {
                    setOnlyEmptyPages(true);
                    return;
                }
            }
        }

        setOnlyEmptyPages(false);
    }, [bridgeDeviceType, bridgeDeviceType?.id, contentType, controlList, currentSTPUIEntity?.relational_id, setOnlyEmptyPages]);


    return (
        <PasswordContainer requiredRole="service" isFullscreen={true}>
            <SettingsPageContainer
                buttons={buttons}
                currentInput={currentInput}
                className="service-edit"
                backUrl={backUrl}>
                <div className="content-divider">
                    <div className="content-wrapper">
                        <SettingReadOnlyRowComponent
                            title={t("device_name")}
                            value={bridgeDevice?.name}/>
                        <SettingInputComponent
                            placeholder={t("write_display_name")}
                            label={t("display_name")}
                            maxLength={bridgeDeviceType.display_name_length}
                            value={displayName}
                            setValue={setDisplayName}
                            setActiveInput={setActiveInput}
                            onBlur={onBlur}/>
                        {
                            renderIf(currentControl != null)(() =>
                                <SettingReadOnlyRowComponent
                                    title={t(currentControl.isVirtual ? 'virtual_control_name' : 'control_name')}
                                    value={currentControl?.control.name}/>,
                            )
                        }
                        {
                            renderIf(currentSTPUIEntity == null)(() =>
                                    <SettingSelectComponent
                                        label={t("type")}
                                        options={contentTypeOptionList}
                                        onChange={setContentType}
                                        value={contentType}/>,
                                (() =>
                                        <SettingReadOnlyRowComponent
                                            title={t("type")}
                                            value={currentControl != null ? controlTypeName : contentType?.label}/>
                                ),
                            )
                        }
                        {
                            renderIf(contentType?.value === 'group')(() =>
                                <SettingSelectComponent
                                    label={t("group_control_type")}
                                    options={GROUP_CONTROL_TYPES}
                                    onChange={setGroupType}
                                    value={groupType}/>,
                            )
                        }
                        {
                            renderIf(!['23','7', '8', '9'].includes(bridgeDeviceType.id))(() =>
                                renderIf(contentType?.value !== 'group')(() =>
                                        <SettingSelectComponent
                                            label={t("page_number")}
                                            options={((currentSTPUIEntity?.type === 'control'||currentSTPUIEntity?.type === 'virtualControl') && currentControl?.control.type_id !== CONTROL_TYPE_ID_THERMOSTAT && bridgeDeviceType.id !== '5') ? controlPageOptionsList : pageOptionList}
                                            onChange={setPageNumber}
                                            value={pageNumber}/>,
                                    () => (
                                        <SettingReadOnlyRowComponent
                                            title={t("page_number")}
                                            value={pageNumber?.label}/>
                                    ),
                                ),
                            )
                        }

                        {
                            renderIf(/*currentControl.id == null && */currentControl?.control?.type_id === CONTROL_TYPE_ID_CURTAIN && bridgeDeviceType?.id === BRIDGE_DEVICE_TYPE_ID_STS_PLUS)(()=> (
                                <SettingCheckBoxComponent label={t('double_button')} set={onClickChangeDoubleButtonStatus} value={doubleButton}/>
                            ))
                        }
                        {
                            renderIf(bridgeDeviceType?.id !== '9' && bridgeDeviceType?.id !== '8' && bridgeDeviceType?.id !== '7' && !(bridgeDeviceType?.id === BRIDGE_DEVICE_TYPE_ID_STPM_F && (currentControl?.control.type_id === CONTROL_TYPE_ID_THERMOSTAT || currentControl?.control.type_id === CONTROL_TYPE_ID_FANCOIL)))(() =>
                                renderIf(contentType?.value !== 'media' && contentType?.value !== 'air' && !(currentControl?.control.type_id === CONTROL_TYPE_ID_THERMOSTAT && bridgeDeviceType.id === '5'))(() =>
                                    <SettingSelectComponent
                                    label={t(bridgeDeviceType.id === '23' ? 'button_number' : 'row_number')}
                                    options={rowOptionList}
                                        onChange={setRowNumber}
                                        value={rowNumber}/>,
                                    ),
                            )
                        }
                        {
                            renderIf((bridgeDeviceType.id === '9' || bridgeDeviceType.id === '8' || bridgeDeviceType.id === '7') && contentType?.value === 'scenario')(() =>
                                <SettingSelectComponent
                                label={t('button_number')}
                                options={(remainingOptionsWithLabel)}
                                onChange={setRowNumber}
                                value={rowNumber}/>,
                            )
                        }

                    </div>
                </div>
            </SettingsPageContainer>
            {
                renderKeyboard()
            }
        </PasswordContainer>
    );
}
